<template>
    <container-page :headerHeight="'18%'" :bodyHeight="'93%'">
        <template v-slot:header>
            <div class="bodyPage" v-if="user.CLIENTE_ID">
                <no-adm-banner message="Área destinada a usuários Operadores!"/>
            </div>
            <div class="headerPage" v-if="!user.CLIENTE_ID">
                <span class="titlePage"> {{'Administrativo' | translate('Administrativo')}} </span>
            </div>
            <div id="borderBottomTabs" class="borderBottomTabs"></div>
            <v-tabs
                v-if="!user.CLIENTE_ID"
                v-resize="onResize"
                height="60px"
                class="headerTabs"
                color="black"
                slider-size="4" 
                v-model="tab"
                show-arrows
            >
                <v-tab class="admTab" id="clientes" @click="changeRouter('/clientes')">
                    <span>{{labels.cadastros}}</span>
                </v-tab>
                <v-tab class="admTab" id="aviso" @click="changeRouter('/aviso')">
                    <span>{{labels.aviso}}</span>
                </v-tab>
            </v-tabs>
        </template>
        <template v-slot:body v-if="!user.CLIENTE_ID">
            <div>
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <router-view />
                    </v-tab-item>
                    <v-tab-item>
                        <router-view />
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </template>
    </container-page>
</template>

<script>
import translate from '../../../src/plugins/translate'
import ContainerPage from '../../../src/components/containerPage.vue'
import NoAdmBanner from '../../../src/components/NoAdmBanner'
import { createNamespacedHelpers } from 'vuex'
const user = createNamespacedHelpers('user')

export default {
    name: 'Administrativo',
    components: {ContainerPage, NoAdmBanner},
    data() {
        return {
            tab: null,
            labels: {
                cadastros: translate('Cadastros', 'Administrativo'),
                aviso: translate('Aviso', 'Administrativo')
            }
        }
    },
    watch:{
        $route (to){
            this.$nextTick(function(){
                let el = document.getElementById(`${to.path.slice(1)}`)
                console.log(to.path)
                el.click()
            })
        }
    },
    methods: {
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            this.buildborderTabs()
        },
        changeRouter(route) {
            if(window.location.pathname != route) this.$router.push(route)
        },
        buildborderTabs() {
            var allTabs = document.getElementsByClassName('admTab')
            var widthBorderBoddom = 0
            allTabs.forEach(function(tab){
                widthBorderBoddom += tab.offsetWidth
            })
            let element = document.getElementById('borderBottomTabs')
            this.$nextTick(function(){
                element.style.width = `${widthBorderBoddom}px`
            })
        }
    },
    mounted(){
        this.onResize()
        setTimeout(function(){
            let el = document.getElementById(`${window.location.pathname.slice(1)}`)
            el.click()
        },120)
        // this.changeRouter('/clientes')
    },
    computed:{
        ...user.mapGetters(['user'])
    },

}
</script>
<style scoped>

.headerPage{
    height: 2em;
}
.titlePage{
    font-size: 20px;
    font-weight: 700;
}
.el-tabs__item.is-active{
    color:black !important;
}
.el-tabs__active-bar{
    background-color: #000000 !important;
}
.admTab > span{
    font-weight: bolder !important;
}
.borderBottomTabs{
    border-bottom: 4px solid #80808052;
    position: relative;
    top: 60px;
    width: 1px;
    z-index: 1;
    border-radius: 50px;
}
</style>
